import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';

export const medispanStagingStyles = (theme: Theme) =>
  createStyles({
    actionBar: {
      display: 'flex',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
      alignItems: 'center',
    },
    statusBanner: {
      padding: theme.spacing(1, 2),
      borderRadius: theme.shape.borderRadius,
      marginBottom: theme.spacing(2),
    },
    rowModified: {
      backgroundColor: '#fff8e1',
    },
    rowNew: {
      backgroundColor: '#e8f5e9',
    },
    rowRemoved: {
      backgroundColor: '#ffebee',
    },
    currentCell: {
      color: theme.palette.text.secondary,
    },
    stagedCell: {
      fontWeight: 600,
    },
    changedValue: {
      color: theme.palette.error.dark,
    },
    emptyState: {
      padding: theme.spacing(4),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    rejectReasonField: {
      marginTop: theme.spacing(2),
    },
  });
